<template>
    <form-row title="Buyer 1">
        <div class="flex-1 -mt-2">
            <div class="flex flex-col sm:flex-row">
                <div class="sm:col-gap-1 flex-1 my-1">
                    <input-text
                        name="contacts[buyer_1][name]"
                        v-model="contact_name"
                        label="Name"
                        placeholder="Name"
                        :read_only="read_only"
                    />
                </div>

                <div class="sm:col-gap-1 flex-1 my-1">
                    <input-text
                        name="contacts[buyer_1][email]"
                        v-model="contact_email"
                        label="Email"
                        placeholder="Email"
                        :read_only="read_only"
                    />
                </div>

                <div class="sm:col-gap-1 flex-1 my-1">
                    <input-text
                        name="contacts[buyer_1][phone]"
                        :value="contact.phone"
                        label="Phone"
                        placeholder="Phone"
                        :read_only="read_only"
                    />
                </div>
            </div>

            <div class="mt-3">
                <input-text
                    label="Address"
                    name="contacts[buyer_1][address_1]"
                    :value="contact.address_1"
                    placeholder="Address"
                    :read_only="read_only"
                />
            </div>

            <div class="mt-3">
                <input-text
                    name="contacts[buyer_1][address_2]"
                    :value="contact.address_2"
                    placeholder="Address 2"
                    :read_only="read_only"
                />
            </div>

            <div class="flex flex-col sm:flex-row sm:mt-3">
                <div class="sm:col-gap-1 flex-1 mt-3 sm:my-1">
                    <input-text
                        name="contacts[buyer_1][city]"
                        :value="contact.city"
                        placeholder="City"
                        :read_only="read_only"
                    />
                </div>

                <div class="sm:col-gap-1 flex-1 mt-3 sm:my-1">
                    <input-select-states
                        name="contacts[buyer_1][state]"
                        no_selection="Select State"
                        :value="contact.state"
                        :read_only="read_only"
                    />
                </div>

                <div class="sm:col-gap-1 flex-1 mt-3 sm:my-1">
                    <input-text
                        name="contacts[buyer_1][zip]"
                        :value="contact.zip"
                        placeholder="Zip"
                        :read_only="read_only"
                    />
                </div>
            </div>
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        contact: { default: () => ({}) },
        property: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            contact_name: this.contact.name,
            contact_email: this.contact.email,
        }
    },

    computed: {
        our_purchase() {
            return store.state.our_purchase;
        },
    },

    watch: {
        our_purchase(val) {
            if (val) {
                if (! this.contact_name) {
                    this.contact_name = this.property.client.name;
                }

                if (! this.contact_email) {
                    this.contact_email = this.property.client.email;
                }
            }
        },
    },
}
</script>
